import Products from "./list";

export default Products;
